import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { BaryModalService } from '../../../../../../services/bary-modal.service';

@Component({
  selector: 'jhi-bary-table-manager-action-button',
  templateUrl: './bary-table-manager-action-button.component.html',
  styleUrls: ['./bary-table-manager-action-button.component.scss'],
})
export class BaryTableManagerActionButtonComponent<T> {
  readonly #modalService = inject(BaryModalService);

  @Input() items?: T & { position?: number }[];
  @Input() tableOptions!: TableOptions;

  @Output() orderChangeEvent = new EventEmitter();
  @Output() newEvent = new EventEmitter();
  @Output() newAndRedirectEvent = new EventEmitter();

  openChangeOrderModal(): void {
    if (this.tableOptions.changeOrderModalLabel) {
      const itemsSorted = this.items?.sort((it1, it2) => it1.position! - it2.position!);
      this.#modalService
        .openChangeOrderModal(this.tableOptions.changeOrderModalLabel, itemsSorted)
        .action()
        .subscribe(action => {
          if (action.submit) {
            this.items?.forEach((it: any, index: number) => {
              it.position = index + 1;
            });
            this.orderChangeEvent.emit(this.items);
          }
        });
    }
  }

  openAddNew(redirect: boolean): void {
    if (this.tableOptions.createModalLabel) {
      (this.#modalService as any)
        [this.tableOptions.createModalLabel]()
        .action()
        .subscribe((action: { submit: any; value: any }) => {
          if (action.submit) {
            if (redirect) {
              this.newAndRedirectEvent.emit(action.value);
            } else {
              this.newEvent.emit(action.value);
            }
          }
        });
    }
  }
}
